<script lang="ts">
import { navigate } from "svelte-navigator";

    import { Button, Icon, Offcanvas, OffcanvasBody } from "sveltestrap";
    import type { Fn } from "../global";
    import { sessionService } from "../Services";

    export let isOpen = false;
    export let toggle: Fn;

    function onLogoutClick() {
        if (!confirm('¿Seguro que desea salir?')) {
            return;
        }
        sessionService.closeSession();
        navigate('/');
    }

</script>

<style lang="scss">

    .content {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        height: 100%;
    }

    .upper-content {
        flex: 1 1 0;
    }

</style>

<Offcanvas {isOpen} {toggle} placement="end" header="Menú" style="width: 300px">

    <div class="content">
        <div class="upper-content">

        </div>
        <Button block color="secondary" on:click={onLogoutClick}>
            <Icon name="door-closed" /> Salir
        </Button>
    </div>

</Offcanvas>